import { ref } from 'vue'
import { api } from '@/global/services/api'

export function useStatuses () {
  const projectStatuses = ref([])
  const projectTypes = ref([])

  const fetchProjectStatuses = async () => {
    try {
      const { data } = await api('road-maintenance').get('statuses', {
        types: ['PROJECT']
      })

      projectStatuses.value = data?.project?.length
        ? data.project
        : []
    }
    catch (e) {
      console.error(e)
    }
  }

  const fetchProjectTypes = async () => {
    try {
      const { data } = await api('road-maintenance').get('codebook', {
        types: ['PROJECT_TYPE']
      })

      projectTypes.value = data?.project_type?.length
        ? data.project_type
        : []
    }
    catch (e) {
      console.error(e)
    }
  }

  return {
    projectStatuses,
    projectTypes,
    fetchProjectStatuses,
    fetchProjectTypes
  }
}
